/**
 * Muscle Grenade — Lista de favoritos (localStorage)
 */
(function () {
  'use strict';

  var GUEST_KEY = 'mg-wishlist-guest';
  var EVT = 'mg-wishlist-change';

  function customerKey() {
    if (window.MG_CUSTOMER && window.MG_CUSTOMER.id) {
      return 'mg-wishlist-' + window.MG_CUSTOMER.id;
    }
    return null;
  }

  function read(key) {
    try {
      var raw = localStorage.getItem(key);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function write(key, items) {
    try {
      localStorage.setItem(key, JSON.stringify(items));
    } catch (e) {}
  }

  function mergeGuestIntoCustomer() {
    var ck = customerKey();
    if (!ck) return;
    var guest = read(GUEST_KEY);
    if (!guest.length) return;
    var current = read(ck);
    var handles = {};
    current.forEach(function (i) { handles[i.handle] = true; });
    guest.forEach(function (i) {
      if (!handles[i.handle]) current.push(i);
    });
    write(ck, current);
    try { localStorage.removeItem(GUEST_KEY); } catch (e) {}
  }

  function getItems() {
    mergeGuestIntoCustomer();
    var ck = customerKey();
    return read(ck || GUEST_KEY);
  }

  function saveItems(items) {
    write(customerKey() || GUEST_KEY, items);
    document.dispatchEvent(new CustomEvent(EVT, { detail: { count: items.length } }));
  }

  function isFavorite(handle) {
    return getItems().some(function (i) { return i.handle === handle; });
  }

  function toggle(item) {
    var items = getItems();
    var idx = -1;
    items.forEach(function (i, n) { if (i.handle === item.handle) idx = n; });
    if (idx >= 0) items.splice(idx, 1);
    else items.unshift(item);
    saveItems(items);
    return idx < 0;
  }

  function updateButtons() {
    document.querySelectorAll('[data-mg-wishlist]').forEach(function (btn) {
      var handle = btn.getAttribute('data-handle');
      var on = isFavorite(handle);
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = btn.getAttribute('data-label-add') || 'Guardar';
      var labelRemove = btn.getAttribute('data-label-remove') || 'Quitar';
      btn.setAttribute('aria-label', on ? labelRemove : label);
    });
    var count = getItems().length;
    document.querySelectorAll('[data-mg-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mg-wishlist]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle({
      handle: btn.getAttribute('data-handle'),
      title: btn.getAttribute('data-title') || '',
      image: btn.getAttribute('data-image') || '',
      url: btn.getAttribute('data-url') || '/products/' + btn.getAttribute('data-handle'),
    });
    updateButtons();
  });

  document.addEventListener(EVT, updateButtons);
  document.addEventListener('DOMContentLoaded', updateButtons);
  updateButtons();

  window.MGWishlist = {
    getItems: getItems,
    toggle: toggle,
    isFavorite: isFavorite,
    renderFavorites: function (container) {
      if (!container) return;
      var items = getItems();
      if (!items.length) {
        container.innerHTML =
          '<div class="mg-acc__empty"><p>No tienes favoritos aún.</p>' +
          '<a href="/collections/all" class="mg-acc__btn">Explorar productos</a></div>';
        return;
      }
      container.innerHTML = '<div class="mg-acc__fav-grid mg-acc__fav-grid--loading">Cargando favoritos...</div>';
      var grid = container.querySelector('.mg-acc__fav-grid');

      Promise.all(items.map(function (item) {
        return fetch('/products/' + item.handle + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (live) {
            return { item: item, live: live };
          })
          .catch(function () { return { item: item, live: null }; });
      })).then(function (rows) {
        grid.classList.remove('mg-acc__fav-grid--loading');
        grid.innerHTML = '';
        rows.forEach(function (row) {
          var p = row.live;
          var it = row.item;
          var title = p ? p.title : it.title;
          var url = p ? '/products/' + p.handle : it.url;
          var img = p && (p.featured_image || (p.images && p.images[0])) || it.image;
          var price = p ? p.price : null;
          var avail = p ? p.available : true;
          var card = document.createElement('article');
          card.className = 'mg-acc__fav-card';
          card.innerHTML =
            (img ? '<img src="' + img + '" alt="" loading="lazy" class="mg-acc__fav-img">' : '<div class="mg-acc__fav-img"></div>') +
            '<div class="mg-acc__fav-body">' +
              '<a href="' + url + '" class="mg-acc__fav-title">' + title + '</a>' +
              (price ? '<span class="mg-acc__fav-price">' + new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }).format(price / 100) + '</span>' : '') +
              (avail ? '' : '<small style="color:#888;">Agotado</small>') +
            '</div>' +
            '<button type="button" class="mg-acc__fav-remove" data-handle="' + it.handle + '" aria-label="Quitar de favoritos">×</button>';
          grid.appendChild(card);
        });

        grid.querySelectorAll('.mg-acc__fav-remove').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var h = btn.getAttribute('data-handle');
            var list = getItems().filter(function (i) { return i.handle !== h; });
            saveItems(list);
            window.MGWishlist.renderFavorites(container);
            updateButtons();
          });
        });
      });
    },
  };
})();